@if (shiftView) {
  @if (
    {
      leftPixel: leftPixelPosition$ | async,
      adjustedLeftPosition: adjustedLeftPosition$ | async,
    };
    as positionData
  ) {
    @if (
      {
        isLoadingValidations:
          shiftCardTooltipStateService.isLoadingValidationsForUser$ | async,
        isShiftValid: shiftCardTooltipStateService.isShiftValid$ | async,
        hasShiftBeenValidated:
          shiftCardTooltipStateService.hasShiftBeenValidated$ | async,
        isLoadingValidationsError:
          shiftCardTooltipStateService.isLoadingValidationsError$ | async,
        isShiftDraggableFeatureFlag:
          'portal-shift-timeline-shift-drag-drop' | featureFlagPure | async,
        shiftWidthPx:
          {
            left: positionData.leftPixel,
            right: rightPixelPosition,
          }
          | timeDifferenceWidthPx: BORDER_SIZE
          | async,
        isShiftSelected:
          shiftMultiSelectHelperService.selectedShifts$
          | isShiftSelected: shiftView.shift.id
          | async,
        shiftIdsToHighlight: shiftIdsToHighlight$ | async,
      };
      as data
    ) {
      <div
        #shiftPreviewCard
        class="shift"
        [class.d-none]="!isShiftVisible"
        [class.is-not-draggable]="
          data.isShiftDraggableFeatureFlag && !isShiftDraggable
        "
        [class.selected]="data.isShiftSelected"
        [class.highlighted]="
          data.shiftIdsToHighlight?.includes(shiftView.shift.id)
        "
        [ngClass]="classPositioning"
        [style.width.px]="data.shiftWidthPx"
        [style.border-width.px]="ACTIVITY_BORDER_PX"
        [style.left.px]="positionData.adjustedLeftPosition"
        [class.filtered]="!shiftView.shift.isHighlighted || isDragging"
        [style.border-left.px]="BORDER_SIZE"
        [style.border-left]="
          'solid ' + shiftCategoriesColorCode[shiftView.shift.shiftCategoryId]
        "
        [draggable]="data.isShiftDraggableFeatureFlag && isShiftDraggable"
        (click)="
          checkShiftKeyOnClick(
            $event,
            shiftView.shift.id!,
            positionData.leftPixel,
            rightPixelPosition,
            undoTemplate
          )
        "
      >
        <wilson-shift-validation-tooltip-wrapper
          [showShiftValidation]="showShiftValidation"
          [plannedShiftStartDateTime]="plannedShiftStartDateTime"
          [plannedShiftEndDateTime]="plannedShiftEndDateTime"
          [accurateShiftStartDateTime]="shiftStartDetail.date"
          [accurateShiftEndDateTime]="shiftEndDetail.date"
          [shiftStartTimeDifference]="shiftStartDetail.timeDifference"
          [shiftEndTimeDifference]="shiftEndDetail.timeDifference"
          [shiftStartTimeType]="shiftStartDetail.type"
          [shiftEndTimeType]="shiftEndDetail.type"
          [plannedStartLocation]="shiftStartDetail.location"
          [plannedEndLocation]="shiftEndDetail.location"
          [reportedStartLocation]="null"
          [reportedEndLocation]="null"
          [displayTooltip]="!!isTooltipVisible"
        >
          <div class="d-flex justify-content-between">
            <div
              class="shift-details"
              [ngStyle]="{
                height: ACTIVITY_TITLE_HEIGHT_PX + 'px',
                'margin-top': ACTIVITY_TITLE_MARGIN_TOP_PX + 'px',
                'margin-bottom': ACTIVITY_TITLE_MARGIN_BOTTOM_PX + 'px',
              }"
            >
              <div
                [ngClass]="
                  data.shiftWidthPx > MIN_WIDTH_PX ? 'shift-name' : 'd-none'
                "
              >
                {{ shiftView.shift.name }}
              </div>
            </div>
            @if (data.shiftWidthPx > MIN_WIDTH_PX) {
              <div class="d-flex">
                <div class="status-icon">
                  <ng-container
                    *ngTemplateOutlet="
                      deferredShiftIconsHelperService.getShiftStatusTemplate();
                      context: {
                        shift: shift,
                        width: '',
                      }
                    "
                  ></ng-container>
                </div>
                <ng-container
                  *ngTemplateOutlet="
                    deferredShiftIconsHelperService.getShiftValidationStatusTemplate();
                    context: {
                      showShiftValidation: showShiftValidation,
                      isLoadingValidations: !!data.isLoadingValidations,
                      hasShiftBeenValidated: !!data.hasShiftBeenValidated,
                      isShiftValid: data.isShiftValid,
                      isLoadingValidationsError:
                        !!data.isLoadingValidationsError,
                    }
                  "
                ></ng-container>
                @if (shift.userId) {
                  <ng-container
                    *ngTemplateOutlet="
                      deferredShiftIconsHelperService.getLastSeenConfirmDeclineStatusTemplate();
                      context: {
                        shift: shift,
                      }
                    "
                  ></ng-container>
                }
              </div>
            }
          </div>
          @for (
            innerRowActivities of shiftView.activitiesInRowLevels;
            track trackByActivityWithOverLevel($index, innerRowActivities)
          ) {
            <wilson-timeline-auto-size-activities-row-within-shift
              [rowActivities]="innerRowActivities"
              [shift]="shiftView.shift"
              [userId]="userId"
              [shiftWidthPx]="data.shiftWidthPx"
              [accurateShiftStartDateTime]="shiftStartDetail.date"
              [accurateShiftEndDateTime]="shiftEndDetail.date"
              [accurateShiftDurationMs]="accurateShiftDurationMs"
              [filteredActivityId]="filteredActivityId"
              [isCursorGrab]="isCursorGrab"
              [isActivityDraggable]="isActivityDraggable"
              (selected)="selectActivity.emit($event)"
            ></wilson-timeline-auto-size-activities-row-within-shift>
          }
        </wilson-shift-validation-tooltip-wrapper>
      </div>
    }
  }
}

<ng-template #undoTemplate>
  <wilson-nz-message-timer-line [duration]="MESSAGE_DURATION">
    <wilson-message-with-undo-option></wilson-message-with-undo-option>
  </wilson-nz-message-timer-line>
</ng-template>
